module.exports = __webpack_public_path__ + "static/media/bq.e53fc83f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bq.svg
// module id = 71
// module chunks = 0